import React from "react";
import { ITaskController } from "../controller";
import { Rect } from "react-konva";
import { TASK_HEIGHT, TASK_WIDTH } from "shared/datamodel/task";
import useObservableController from "elements/hooks/use-observable-controller";
import { transformerRefAtom } from "state-atoms";
import { useAtomValue } from "jotai";
import { BORDER_HEIGHT } from "../consts";

export const TaskBackground = React.memo(({ controller }: { controller: ITaskController }) => {
  const transformerRef = useAtomValue(transformerRefAtom);
  useObservableController(controller, ["size-changed", "fill-changed"], () => {
    transformerRef?.current?.forceUpdate();
  });

  const { element } = controller;
  const { width = TASK_WIDTH, height = TASK_HEIGHT, fill } = element;

  return (
    <>
      <Rect width={width} height={height} fill={fill} cornerRadius={10} perfectDrawEnabled={false} listening={false} />
      <Rect
        y={BORDER_HEIGHT}
        width={width}
        height={height}
        fill="white"
        cornerRadius={10}
        stroke="#EBEDF3"
        strokeWidth={1}
        perfectDrawEnabled={false}
        listening={false}
        shadowColor="black"
        shadowBlur={14}
        shadowOpacity={0.1}
        shadowForStrokeEnabled={false}
      />
    </>
  );
});

TaskBackground.displayName = "TaskBackground";
